// extracted by mini-css-extract-plugin
export default {"mainContainer":"precisionSlider_mainContainer__UqpEb","sliderBox":"precisionSlider_sliderBox__6zSmj"};